module.exports = __webpack_public_path__ + "images/black_bg2.png";